import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router, RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { NativeService } from './services/native.service';
import * as CordovaSQLiteDriver from 'localforage-cordovasqlitedriver';
import { IonicStorageModule } from '@ionic/storage-angular';
import { Drivers } from '@ionic/storage';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';
import { ApiModule } from './services/api/api.module';
import { environment } from 'src/environments/environment';
import { HttpBackend, provideHttpClient, withInterceptors } from '@angular/common/http';
import { apiAuthInterceptor } from './services/auth/auth.interceptor';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import * as Sentry from "@sentry/angular";
import { ServiceWorkerModule } from '@angular/service-worker';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { createTranslateLoader } from './i18n/empty-skipping-translate-loader';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    // `mode: 'ios'` also turns on Ionic's edge swipe-to-go-back gesture on every
    // platform. In this app navigation is driven by explicit state (a live game
    // being tracked, a recording in progress), so an accidental edge swipe pops
    // the route out from under that state and leaves the app inconsistent —
    // hence the gesture is disabled globally.
    IonicModule.forRoot({ mode: 'ios', swipeBackEnabled: false }),
    ApiModule.forRoot({rootUrl: environment.apiUrl}),
    IonicStorageModule.forRoot({
      driverOrder: isNativePlatform() ? [CordovaSQLiteDriver._driver] : [Drivers.LocalStorage],
    }),
    // PWA only: inside the Cordova webview the app is already bundled locally,
    // so a service worker would only add a stale caching layer.
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production && !isNativePlatform(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    // Translations are loaded at runtime from `assets/i18n/<lang>.json`, which the
    // Angular build copies verbatim — so the same files serve the PWA and the
    // Cordova webview. `createTranslateLoader` documents why it takes the raw
    // HttpBackend instead of HttpClient.
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpBackend],
      },
    }),
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    NativeService,
    File,
    provideHttpClient(
      withInterceptors([apiAuthInterceptor])
    ),
    AppVersion,
    SocialSharing,
    ScreenOrientation,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    }, {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

// Helper function to detect native platform
export function isNativePlatform(): boolean {
  return !!(window as any).cordova;
}
